module.exports = __webpack_public_path__ + "img/try_7.a327a6c6.png";